import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import { StateProvider } from "./state/index";
import * as serviceWorker from './serviceWorker';
import './utils/amazon';
import './utils/finix'; // TODO check for finix load in recipient flow
import './utils/logging';
import { I18nextProvider } from "react-i18next";
import i18n from "./utils/i18n";

const Index = () => (
  <I18nextProvider i18n={i18n}>
    <StateProvider><App/></StateProvider>
  </I18nextProvider>
);

const rootElement = document.getElementById("root");
ReactDOM.render(<Index />, rootElement);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

